global.documentsRoute='https://www.charisma-formation.fr/documents/';
global.api = "https://www.charisma-formation.fr/api/charisma"